/**
 * 设置 storeId
 * @param {Object} route - 当前页面的路由对象
 * @returns {number} - 返回最终的 storeId
 */
export function setStoreIdFromRouteOrLocalStorage(route) {
  let storeId = 0;

  // 1️⃣ 优先从 URL 参数中获取 storeId
  const queryStoreId = parseInt(route.query.id || route.query.storeId) || 0;

  if (queryStoreId > 0) {
    storeId = queryStoreId;

    // ✅ 修正 this.storeId 的错误引用，改为 storeId
    localStorage.setItem("currentStoreId", storeId.toString());
    localStorage.setItem("lockStoreId", storeId.toString()); // 设置锁定的店铺 ID
  } else {
    // 2️⃣ 从本地存储中获取锁定 ID 或默认 ID
    const lockStoreId = parseInt(localStorage.getItem('lockStoreId')) || 0;
    const defaultStoreId = parseInt(localStorage.getItem('storeId')) || 0;

    // 优先使用锁定 ID，如果没有则使用默认的 storeId
    storeId = lockStoreId > 0 ? lockStoreId : defaultStoreId;
  }

  return storeId;
}



// WEBPACK FOOTER //
// ./src/utils/store.js